"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBloodPressure = createBloodPressure;
const events_1 = require("../../../events");
const queries_1 = require("../queries");
const messages = {
    bloodPressure: {
        id: "ktx.dashboard.blood_pressure",
        defaultMessage: "Vérnyomás"
    },
    systolicBloodPressure: {
        id: "ktx.dashboard.blood_pressure.field.systolic",
        defaultMessage: "Szisztolés"
    },
    diastolicBloodPressure: {
        id: "ktx.dashboard.blood_pressure.field.diastolic",
        defaultMessage: "Diasztolés"
    },
    heartRate: {
        id: "ktx.dashboard.blood_pressure.field.heart_rate",
        defaultMessage: "Szívfrekvencia"
    }
};
function createBloodPressure({ formatMessage }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.otherQueries.bloodPressure);
    if (event === undefined) {
        return undefined;
    }
    const systolicBloodPressure = {
        type: "list-item",
        label: formatMessage(messages.systolicBloodPressure),
        value: `${event.value.systolicBloodPressure}`
    };
    const diastolicBloodPressure = {
        type: "list-item",
        label: formatMessage(messages.diastolicBloodPressure),
        value: `${event.value.diastolicBloodPressure}`
    };
    const heartRate = {
        type: "list-item",
        label: formatMessage(messages.heartRate),
        value: `${event.value.heartRate}`
    };
    const items = [
        systolicBloodPressure,
        diastolicBloodPressure,
        heartRate
    ];
    const { origin } = event;
    return {
        type: "list",
        attachments: (0, events_1.mapEventsToAttachments)(event),
        origin,
        label: formatMessage(messages.bloodPressure),
        items
    };
}
